export default "__VITE_ASSET__DOEbpUKL__"